import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt, faCog, faFileAlt, faBullseye, faUsers,
  faEnvelope, faMoneyBillWave, faWallet, faCreditCard,
  faHourglassHalf, faUserCircle, faHistory, faTrophy, faMedal, faBullhorn, faTicketAlt
} from '@fortawesome/free-solid-svg-icons';
import { authAPI, dashboardAPI } from '../services/api';
import Footer from './Footer';
import './Settings.css';

function ClubSettings() {
  const { clubId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [clubName, setClubName] = useState('');

  useEffect(() => {
    dashboardAPI.getClubDashboard(clubId).then((data) => {
      setClubName(data.club?.name || 'Club');
    }).catch(() => {});
  }, [clubId]);

  const menuItems = [
    { path: `/dashboard/${clubId}`, label: 'Dashboard', icon: faTachometerAlt },
    { path: `/club/${clubId}/edit`, label: 'Manage Club', icon: faCog },
    { path: `/club/${clubId}/statement`, label: 'Club Statement', icon: faFileAlt },
    { path: `/club/${clubId}/goals`, label: 'Manage Goals', icon: faBullseye },
    { path: `/club/${clubId}/members`, label: 'Manage Members', icon: faUsers },
    { path: `/club/${clubId}/invite`, label: 'Invite Your Mates', icon: faEnvelope },
    { path: `/club/${clubId}/lotto`, label: 'Lotto Syndicate', icon: faTicketAlt },
    { path: `/club/${clubId}/broadcast`, label: 'Broadcast', icon: faBullhorn },
    { path: `/club/${clubId}/withdrawals`, label: 'Club Withdrawals', icon: faMoneyBillWave },
    { path: `/club/${clubId}/fund`, label: 'Fund Club Account', icon: faWallet },
    { path: `/club/${clubId}/subscription`, label: 'Club Subscription', icon: faCreditCard },
    { path: `/club/${clubId}/pending-bets`, label: 'Pending Club Bets', icon: faHourglassHalf },
    { path: `/club/${clubId}/history`, label: 'Club History', icon: faHistory },
    { path: `/club/${clubId}/competitions`, label: 'Competitions', icon: faTrophy },
    { path: `/club/${clubId}/achievements`, label: 'Achievements', icon: faMedal },
    { path: `/club/${clubId}/bookie`, label: 'Personal GRSBet Account', icon: faUserCircle },
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    authAPI.logout();
    navigate('/login');
  };

  return (
    <div className="settings-wrapper">
      <header className="settings-app-header">
        <div className="header-container">
          <div className="header-logo">
            <img src="/logo.png" alt="Punt Club" />
            <h1>Punt Club</h1>
          </div>
          <div className="header-user">
            <Link to={`/dashboard/${clubId}`} className="back-link">
              &larr; {clubName}
            </Link>
            <Link to="/settings/personal" className="back-link">
              Account Settings
            </Link>
            <button onClick={handleLogout} className="btn-logout">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="settings-container">
        <div className="settings-header">
          <h2>{clubName} Settings</h2>
        </div>

        <div className="settings-content">
          <nav className="settings-menu">
            <ul>
              {menuItems.map((item) => (
                <li key={item.path} className={isActive(item.path) ? 'active' : ''}>
                  <Link to={item.path}>
                    <span className="menu-icon">
                      <FontAwesomeIcon icon={item.icon} />
                    </span>
                    <span className="menu-label">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="settings-page">
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ClubSettings;
